module.exports = __webpack_public_path__ + "img/generic.154c31d1.svg";